module.exports = __webpack_public_path__ + "static/media/truck_5_5t.c6d90c51.svg";